import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router';
import ReactGA from 'react-ga';

import { SEOTypeToType } from '../helpers';

import SearchResultsWrapper from './SearchResultsWrapper';
import VendorProfileWrapper from './VendorProfileWrapper';

export default function App() {
  useEffect(() => {
    ReactGA.initialize('UA-71995572-8');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <Switch>
      <Route
        path="/"
        exact
        render={() => {
          return <div>Domain root</div>;
        }}
      />
      <Route
        path="/:type/:areaLevel1/:areaLevel2?/find/:tag"
        exact
        render={({ match }) => {
          const { type, areaLevel1, areaLevel2, tag } = match.params;
          return (
            <SearchResultsWrapper
              area_level_1={areaLevel1}
              area_level_2={areaLevel2}
              type={SEOTypeToType(type)}
              tag={tag}
            />
          );
        }}
      />
      <Route
        path="/:type/:areaLevel1/:areaLevel2?"
        exact
        render={({ match }) => {
          const { type, areaLevel1, areaLevel2 } = match.params;
          return (
            <SearchResultsWrapper
              area_level_1={areaLevel1}
              area_level_2={areaLevel2}
              type={SEOTypeToType(type)}
            />
          );
        }}
      />
      <Route
        path="/:type/:areaLevel1/:areaLevel2/:slug"
        exact
        render={({ match }) => {
          const { type, slug } = match.params;
          return <VendorProfileWrapper slug={slug} />;
        }}
      />
    </Switch>
  );
}
